import { useState } from "react";
import { IconButton, Button,  Grid, FormControl, InputLabel, Select, MenuItem, TextField } from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit'
import HeaderModal from "../../../../global/headerModal";
import BackDrop from "./../../../../global/BackDrop";
import ModalBase from "./../../../../global/ModalBase";
import { FormularioItemStyle } from "./FormularioItemStyles";
import { useFormik } from "formik";
import * as yup from "yup";
import useApi from "./../../../../hooks/useAPI";
import { ToastMessage } from "../../../../global/ToastMessage";
import { useSelector, useDispatch } from "react-redux";
import { actulizarCompraItem, obtenerComprasItemPaquete } from "./../../../../ducks/viajeCalendarioDuck"
import { useEffect } from "react";

const validationSchema = yup.object({
    monto: yup
        .number("Ingresa un monto")
        .positive("Monto postivo")
        .required("Monto es requerido"),
});

const ModalFormulario = (props) => {
    const {
        open = true,
        Monto = 0,
        moneda = 0,
        setOpen = () => { },
        idCompra = 0
    } = props;

    const dispatch = useDispatch()
    const { cliente } = useSelector(store => store.calendario)
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const classes = FormularioItemStyle()
    const [load, setLoad] = useState(false)
    const [tipoMoneda, setTipoMoneda] = useState(0)
    
    const formik = useFormik({
        initialValues: {
            monto: Monto
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            onUpdate(values)
        },
    });
    
    useEffect(() => {
        setTipoMoneda(moneda)
    },[moneda])

    const onUpdate = (values) => {
        setLoad(true)
        dispatch(actulizarCompraItem({
            idCompra: idCompra,
            idMoneda: tipoMoneda,
            MontoProveedor: values.monto
        })).then(Response => {
            switch (Response.status) {
                case 500:
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema de conexión con el servidor",
                    });
                    break;
                case 400:
                    ToastMessage.fire({
                        icon: "warning",
                        title: "<strong>Atención</strong>",
                        text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
                    });
                    break;
                default:
                    handleClose();
                    dispatch(obtenerComprasItemPaquete({ IdPaquete: cliente.paquete?.Id_Paquete }))
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    });
                    break;
            }
            setLoad(false)
        })
    }

    const handleClose = () => {
        setOpen(false)
        setLoad(false)
    }

    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }

    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo="Editar Item"
            />
            <form onSubmit={formik.handleSubmit}>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12}>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                            <Select
                                labelId="lTipoMoneda"
                                id="STipoMoneda"
                                name="tipoMoneda"
                                value={tipoMoneda}
                                onChange={handleSelecTipoMoneda}
                                label="Moneda"
                            >
                                <MenuItem value="0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {catalogoMoneda.map((moneda, index) => (
                                    <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                        {`${moneda.Clave} - ${moneda.Descripcion}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            required
                            id="input-Monto"
                            label="Monto"
                            type="text"
                            variant="outlined"
                            name="monto"
                            value={formik.values.monto}
                            onChange={formik.handleChange}
                            error={formik.touched.monto && Boolean(formik.errors.monto)}
                            helperText={formik.touched.monto && formik.errors.monto}
                            className={classes.textField}
                        />
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
                <BackDrop open={load} />
            </form>
        </ModalBase>
    )
}

const FormularioAItem = (props) => {
    const { idCompra, monto, moneda } = props
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <IconButton variant="outlined" onClick={onClick}>
                <EditIcon />
            </IconButton>
            <ModalFormulario
                idCompra={idCompra}
                Monto={monto}
                moneda={moneda}
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
export default FormularioAItem